import { useQueryClient } from '@tanstack/react-query';
import bookingServices from '../services/booking.service';

export const usePrefetchBookings = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      const nextFilters = { ...filters, page: nextPage };
      queryClient.prefetchQuery({
        queryKey: ['bookings', nextFilters.page, nextFilters.limit, nextFilters.status, nextFilters.bookingType, nextFilters.paymentStatus, nextFilters.customerId, nextFilters.sellerId, nextFilters.serviceId, nextFilters.assignedStaffId, nextFilters.startDate, nextFilters.endDate, nextFilters.search, nextFilters.sortBy, nextFilters.sortOrder],
        queryFn: () => bookingServices.getBookings(nextFilters),
        staleTime: 30 * 1000,
      });
    }
  };

  const prefetchBooking = (bookingId) => {
    queryClient.prefetchQuery({
      queryKey: ['booking', bookingId],
      queryFn: () => bookingServices.getBookingById(bookingId),
      staleTime: 30 * 1000,
    });
  };

  return { prefetchNextPage, prefetchBooking };
};
